import React from 'react';
import { Formik, Field } from 'formik';
import { Grid } from '@inplayer-org/inplayer-ui';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

const { Container, Cell } = Grid;

interface FormValues {
  partner_id: string;
  uiconfig_id: string;
  entry_id: string;
}

const defaultValues: FormValues = {
  partner_id: '',
  uiconfig_id: '',
  entry_id: '',
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOly: boolean;
  closePanel: () => void;
}

const StreamAMGContent = ({ rawContent, onSubmit, formId, isReadOly, closePanel }: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    ...JSONparse(rawContent).value,
  };

  const handleSubmit = (data: FormValues) => {
    const contentString = JSON.stringify(data);
    const { entry_id: externalAssetId } = data;

    onSubmit(contentString, externalAssetId);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell>
                <Field
                  tag="text_input_partner_id"
                  name="partner_id"
                  label="Partner ID"
                  component={Input}
                  disabled={isReadOly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_uiconfig_id"
                  name="uiconfig_id"
                  label="Uiconfig ID"
                  component={Input}
                  disabled={isReadOly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_entry_id"
                  name="entry_id"
                  label="Entry ID"
                  component={Input}
                  disabled={isReadOly}
                />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default StreamAMGContent;
